<template>
    <div :class="{ uploaded: withPreview && uploaded }">
        <x-modal
            class="slim-modal"
            style="z-index: 200000; position: fixed"
            :dropzone="true"
            :loading="uploading"
            :draggable="true"
            @cancel="closeUpload"
            :parent="true"
            width="500"
            @ok="submitPressed = true"
            v-if="showDocumentUploadModal && modal"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                {{ title }}
            </div>

            <slim-multi
                :submitPressed="submitPressed"
                @uploading="uploadingStatus"
                @success="closeModalSuccessful"
                @hasFiles="checkHasFiles"
                default-input-name="file"
                :options="slimOptions"
                :extraFields="computedExtraFields"
                :endpoint="endpoint"
                :label="label"
                :dropzone="true"
                :disabled="disabled"
            ></slim-multi>

            <div slot="footer" style="width: 100%" :class="`d-flex justify-content-between align-items-center`">
                <div class="file-type">
                    <el-select
                        v-model="newDocumentCategory.selected"
                        value-key="id"
                        placeholder="Select Document Type"
                        class="w-100"
                        filterable
                        popper-class="document-types"
                        v-if="showFileTypeSelector"
                    >
                        <el-option-group
                            v-for="(group, index) in documentTypes.keys()"
                            :key="`option-${group}-${index}`"
                            :label="group"
                        >
                            <el-option
                                v-for="(item, index) in documentTypes.get(group)"
                                :key="`value-${item.id}-${index}`"
                                :label="`${item.name}`"
                                :value="item.name"
                            >
                                <span :title="item.name">{{ item.name }}</span>
                            </el-option>
                        </el-option-group>
                    </el-select>
                </div>

                <div class="file-actions">
                    <el-button size="default" @click="closeUpload">Cancel</el-button>
                    <el-button type="success" size="default" @click="submitForm">Upload</el-button>
                </div>
            </div>
        </x-modal>

        <el-button
            v-if="modal && !icon && !circle"
            :disabled="successful ? true : false || disabled"
            type="primary"
            size="default"
            @click="openModal"
        >
            {{ uploadButtonText }}
        </el-button>

        <el-button
            icon="fas fa-upload"
            circle
            size="mini"
            type="primary"
            class="action"
            :class="{ preview: text }"
            v-if="modal && circle"
            @click.prevent.stop="openModal"
            :disabled="successful ? true : false || disabled"
        ></el-button>

        <a
            class="action"
            :class="{ preview: text }"
            v-if="modal && icon && !circle"
            @click.prevent.stop="openModal"
            :disabled="successful ? true : false || disabled"
        >
            <font-awesome-icon :icon="['fas', 'file-upload']" @mousedown.stop />
            <span v-if="text" v-html="text"></span>
        </a>

        <slim-multi
            v-if="!modal"
            :submitPressed="submitPressed"
            @uploading="uploadingStatus"
            @success="closeModalSuccessful"
            @hasFiles="checkHasFiles"
            default-input-name="file"
            :options="slimOptions"
            :extraFields="extraFields"
            :endpoint="endpoint"
            :label="label"
        ></slim-multi>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"

function groupBy(list, keyGetter) {
    const map = new Map()
    list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
            map.set(key, [item])
        } else {
            collection.push(item)
        }
    })
    return map
}

import XModal from "@shared/components/modal/Modal.vue"
import SlimMulti from "@shared/components/slim/slimMulti.vue"

export default {
    name: "file-upload",
    components: {
        XModal,
        SlimMulti,
    },
    props: {
        type: {
            type: String,
            default: "document",
        },
        showFileTypeSelector: {
            type: Boolean,
            default: false,
            required: false,
        },
        fileTypeSelectorRequired: {
            type: Boolean,
            default: false,
            required: false,
        },
        selectorDocumentNames: {
            type: Array,
            required: false,
            default: function () {
                return []
            },
        },
        autoSelectDocType: {
            type: String,
            required: false,
            default: "",
        },
        title: {
            type: String,
            default: "Upload Documents",
        },
        endpoint: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
        icon: {
            type: Boolean,
            default: false,
        },
        circle: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: false,
            default: 'Drop files here <b><em>or</em></b> <span style="text-decoration: underline;">click to browse</span>',
        },
        modal: {
            type: Boolean,
            default: false,
        },
        uploadTriggerText: {
            default: "Upload Documents",
        },
        extraFields: {
            required: false,
        },
        withPreview: {
            required: false,
            default: false,
        },
        document: {
            required: false,
        },
        nomargin: {
            default: false,
        },
        text: {
            type: String,
        },
        autoUpload: {
            type: Boolean,
            default: false,
        },
        backend: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            showDocumentUploadModal: false,
            uploading: false,
            uploaded: false,
            submitPressed: false,
            pdf: {},
            hasFiles: false,
            files: [],
            // fileTypes: [],
            newDocumentCategory: {
                selected: "",
            },
            slimOptions: {
                initialImage: this.placeholder,
                jpegCompression: 30,
                dataRatio: "free",
                buttonEditLabel: '<i class="el-icon-edit-outline"></i>',
                buttonUploadLabel: '<i class="el-icon-upload"></i>',
                buttonRemoveLabel: '<i class="el-icon-document-delete"></i>',
                post: "output",
                push: this.autoUpload,
                forceType: "jpg",
                label: this.label,
                size: "2480, 3508",
                meta: this.extraFields,
            },
            successful: false,
        }
    },
    created() {
        // this.getFileTypes();
    },
    computed: {
        ...mapGetters({
            fileTypes: "documents/fileTypes",
        }),
        buttonDisabled() {
            if (this.fileTypeSelectorRequired && this.newDocumentCategory.selected == "") return true
            return !this.hasFiles ? true : false
        },
        computedExtraFields() {
            return { ...this.extraFields, ...this.newDocumentCategory, ...{ backend: this.backend } }
        },
        uploadButtonText() {
            return this.successful ? this.successful : this.uploadTriggerText
        },
        documentTypes() {
            let fileTypes = this.fileTypes

            if (!_.isEmpty(this.selectorDocumentNames)) {
                fileTypes = this.fileTypes.filter((fileType) =>
                    this.selectorDocumentNames.find((document) => document == fileType.name)
                )
            }

            return groupBy(fileTypes, (doc) => {
                return (
                    (doc.document_type && doc.document_type != "null") || undefined ? doc.document_type : "others"
                ).toUpperCase()
            })
        },
    },
    watch: {},
    mounted() {
        if (this.document && this.document.file_name) {
            this.files.push(this.document.file_name)
        }

        if (!_.isEmpty(this.autoSelectDocType)) {
            this.newDocumentCategory.selected = this.autoSelectDocType
        }
    },
    updated() {},
    activated() {},
    methods: {
        closeUpload() {
            this.showDocumentUploadModal = false
            this.hasFiles = false
        },
        checkHasFiles(data) {
            this.hasFiles = data
        },
        filenames(data) {
            this.files = data
        },
        submitForm() {
            this.submitPressed = true
        },
        openModal() {
            this.showDocumentUploadModal = true
        },
        closeModal() {
            this.showDocumentUploadModal = false
        },
        closeModalSuccessful(res) {
            this.successful = "Successful Upload"
            this.$emit("uploadSuccess", res)
            setTimeout(() => {
                this.successful = false
                this.submitPressed = false
                this.closeModal()
            }, 2000)
        },
        uploadingStatus(data) {
            this.uploading = data
        },
        getFileTypes() {
            let adminUrl = process.env.MIX_APP_URL
            let adminHeaders = {
                headers: { Authorization: "Bearer " + this.$store.getters.adminToken },
            }
            axios.get(adminUrl + "/api/documents", adminHeaders).then((res) => {
                this.fileTypes = res.data
                this.fileTypes.push({
                    id: null,
                    name: "Others",
                })
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.file-type {
    width: 50%;
}

section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.uploaded {
        display: block;
    }

    .slim {
        width: 100%;
    }
}

.slim-btn {
    font-size: 1em;
    background-image: none;
}
.btn-success {
    // &[disabled] {
    //   background-color: #fff;
    //   background-color: #fff;
    //   color: #28a744!important;
    // }
}
.document {
    height: 20rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
}

.action.preview {
    color: #555555 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 1rem;
    cursor: pointer !important;
}
</style>

<style lang="scss">
.slim-modal {
    .modal-body {
        overflow: hidden;
        overflow-y: scroll;
        max-height: 65vh;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>
